import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';

function FormErrorMessage({ name }) {
  return (
    <ErrorMessage
      name={name}
      render={(errorMessage) => (
        <div style={{ color: 'rgb(230, 0, 0)' }}>{errorMessage}</div>
      )}
    />
  );
}

FormErrorMessage.propTypes = {
  name: PropTypes.string,
};

export default FormErrorMessage;
